import {
	Container,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Text,
	ContainerGutter,
	ReferenceBadge,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { useIsLandscape } from '../../../../../../../../hooks/use-is-landscape';
import { huchaLinesColor } from '../../../../../../../../helpers/color-tokens';
import {
	Super200ResponsiveTextRenovadoresPopup,
	Super200SymbolResponsiveTextRenovadoresPopup,
} from '../../../ui/money-font-styles';

const MainContainer = styled.div<{ $landscape: boolean }>`
	padding: 0px;
	align-content: center;

	/* Tablet landscape */
	@media (min-width: 960px) and (max-width: 1279px) {
		${({ $landscape }) =>
			$landscape &&
			`
			padding-top: 16px;
			padding-right: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		`}
	}

	/* Desktop */
	@media (min-width: 1280px) {
		padding-top: 16px;
		padding-right: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
`;

const StyledC2Wrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	align-content: center;
	padding-left: 4px;
	padding-right: 4px;

	margin-left: auto;
	margin-right: auto;

	min-width: 90%;
	height: 186px;
`;

const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 20px;
`;

export const PopupHuchaRenovadoresCardC2: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	const badge = '1';
	const isLandscape = useIsLandscape();

	return (
		<MainContainer $landscape={isLandscape} data-testid="popup-c2-container">
			<StyledC2Wrapper
				data-testid="popup-c2-inner-container"
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0020}
			>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.center}
					bold
				>
					{'Llevas acumulado'}
				</Text>
				<Container wrap="never" horizontalAlign="center">
					<Container wrap="never" verticalAlign="flex-end">
						<Super200ResponsiveTextRenovadoresPopup color={TokenTextColor.inverted}>
							{dineroHucha}
						</Super200ResponsiveTextRenovadoresPopup>
						<Super200SymbolResponsiveTextRenovadoresPopup color={TokenTextColor.inverted}>
							{'€'}
						</Super200SymbolResponsiveTextRenovadoresPopup>
					</Container>
					<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
				</Container>
			</StyledC2Wrapper>
		</MainContainer>
	);
};
